import PropTypes from "prop-types"
import { OPTION_SHAPE } from "components/list-item-dropdown"
import CurrencyBasisDialog from "./components/currency-basis-dialog"
import { SUPPORTED_METRICS_SHAPE, METRICS_SHAPE, METRIC_TYPES_SHAPE } from "helpers/metrics/shapes"
import MetricDisplayUnitSelector from "./components/metric-display-selector"
import SettingsButton from "./components/settings-button"

import "./styles.scss"

export default function DefaultMetricUnitSelector({ options, metric, unit, onChange, alignMenu = "center", classes, supportedMetrics, includeUnitSelector = false, updateDefaultMetrics, openDialog, closeDialog, disabled }) {
  const openSettingsDialog = () => {
    openDialog({
      content: <CurrencyBasisDialog {...{
        options,
        supportedMetrics,
        currentMetric: metric,
        updateDefaultMetrics,
        closeDialog,
      }}
      />,
    })
  }

  if (includeUnitSelector) {
    return <MetricDisplayUnitSelector {...{ options, unit, classes, alignMenu, onChange, openSettingsDialog, disabled, metric }} />
  }

  return <SettingsButton {...{ onClick: openSettingsDialog }} />
}

DefaultMetricUnitSelector.propTypes = {
  alignMenu: PropTypes.string,
  classes: PropTypes.object,
  unit: METRIC_TYPES_SHAPE.isRequired,
  metric: METRICS_SHAPE.isRequired,
  options: PropTypes.arrayOf(OPTION_SHAPE).isRequired,
  onChange: PropTypes.func,
  openDialog: PropTypes.func.isRequired,
  closeDialog: PropTypes.func.isRequired,
  updateDefaultMetrics: PropTypes.func.isRequired,
  supportedMetrics: SUPPORTED_METRICS_SHAPE.isRequired,
  includeUnitSelector: PropTypes.bool,
  disabled: PropTypes.bool,
}
